import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Center mih="60vh">
      <Stack align="center" gap="md">
        <Title order={2}>Not found</Title>
        <Text c="dimmed">That page doesn’t exist.</Text>
        <Button onClick={() => navigate('/')}>Go home</Button>
      </Stack>
    </Center>
  );
}
